import React from 'react';
import GlobalFooter from './components/GlobalFooter';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Page Header */}
      <section className="py-16 bg-gradient-to-br from-green-50 to-blue-50">
        <div className="container mx-auto px-4 max-w-4xl text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Privacy Policy
          </h1>
          <p className="text-xl text-gray-600">
            Your privacy is important to us. Last updated: October 2025
          </p>
        </div>
      </section>

      {/* Privacy Policy Content */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="prose prose-lg max-w-none space-y-8">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Data We Collect</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• Contact information (name, email, phone number)</li>
                <li>• Location data (GPS coordinates, address)</li>
                <li>• Usage data (app interactions, food rescue activities)</li>
                <li>• Device information (for app functionality)</li>
              </ul>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">How We Use Your Data</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• Match surplus food with nearby NGOs</li>
                <li>• Optimize delivery routes for transporters</li>
                <li>• Provide analytics on food rescue impact</li>
                <li>• Improve our matching algorithms</li>
                <li>• Send important service notifications</li>
              </ul>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Data Protection</h3>
              <p className="text-gray-700">
                We use industry-standard security measures to protect your data. Your information is encrypted 
                in transit and at rest. We never sell your personal data to third parties.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Your Rights</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• Access your personal data</li>
                <li>• Correct inaccurate information</li>
                <li>• Delete your account and data</li>
                <li>• Opt out of marketing communications</li>
                <li>• Data portability (download your data)</li>
              </ul>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Data Sharing</h3>
              <p className="text-gray-700">
                We only share your data with trusted partners necessary for service delivery. This includes 
                transport partners for deliveries and verification services for safety compliance. We never 
                sell or lease your personal information to third parties.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Cookies and Tracking</h3>
              <p className="text-gray-700">
                We use essential cookies to ensure proper functionality of our platform. Optional cookies 
                help us improve user experience and analyze usage patterns. You can control cookie preferences 
                in your browser settings.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Data Retention</h3>
              <p className="text-gray-700">
                We retain your data only as long as necessary for service provision and legal compliance. 
                Account data is retained for active accounts, and deleted accounts are purged within 30 days 
                unless required for legal purposes.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">International Transfers</h3>
              <p className="text-gray-700">
                Your data may be processed in countries where our service providers operate. We ensure 
                appropriate safeguards are in place for international data transfers in compliance with 
                applicable privacy laws.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Contact Us</h3>
              <p className="text-gray-700">
                For privacy-related questions, contact us at privacy@foodconnect.asia or 
                through the contact form in our app. We respond to privacy inquiries within 48 hours.
              </p>
            </div>

            <div className="bg-green-50 p-6 rounded-lg border border-green-200">
              <h3 className="text-xl font-semibold text-green-900 mb-3">Updates to This Policy</h3>
              <p className="text-green-800">
                We may update this Privacy Policy periodically to reflect changes in our practices or legal 
                requirements. We will notify users of significant changes via email or in-app notifications. 
                Continued use of our services after updates constitutes acceptance of the revised policy.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Global Footer */}
      <GlobalFooter />
    </div>
  );
};

export default PrivacyPolicy;